import React, { useState } from 'react';
import { auth } from '../lib/firebase';
import {
  EmailAuthProvider,
  reauthenticateWithCredential,
} from 'firebase/auth';
import { X, Lock } from 'lucide-react';
import { toast } from 'sonner';

const ReAuthModal = ({ onSuccess, onClose }) => {
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleReAuth = async () => {
    if (!password) {
      toast.error('Enter your password');
      return;
    }

    setLoading(true);
    try {
      const credential = EmailAuthProvider.credential(
        auth.currentUser.email,
        password
      );

      await reauthenticateWithCredential(auth.currentUser, credential);
      toast.success('Re-authenticated successfully');
      onSuccess();
      onClose();
    } catch {
      toast.error('Incorrect password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center">
      <div className="bg-neutral-charcoal border border-white/10 rounded-xl w-full max-w-md p-6 relative">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-neutral-silver hover:text-white"
        >
          <X size={18} />
        </button>

        <h2 className="text-xl font-bold text-white mb-4">
          Confirm your password
        </h2>

        <p className="text-neutral-silver mb-6 text-sm">
          For security reasons, please confirm your password to continue.
        </p>

        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="w-full px-4 py-3 mb-4 rounded-lg border border-white/10"
          style={{
            backgroundColor: '#2a2b2d',
            color: '#fff',
            WebkitTextFillColor: '#fff',
          }}
        />

        <button
          onClick={handleReAuth}
          disabled={loading}
          className="w-full flex items-center justify-center gap-2 px-4 py-3 bg-accent-teal text-white rounded-lg"
        >
          <Lock size={16} />
          {loading ? 'Verifying…' : 'Confirm'}
        </button>
      </div>
    </div>
  );
};

export default ReAuthModal;
